import { styled } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles(() => ({
  wrapper: {
    "& .MuiDrawer-paper": {
      background: "transparent",
      boxShadow: "none",
      display: "flex",
      flexDirection: "row",
    },
  },
  sectionWrapper: {
    height: "calc(100% - 30px)",
  },
  sectionWrapperNavList: {
    height: "calc(100% - 30px)",
    display: "flex",
    flexDirection: "column",
  },
  sectionWrapperMenu: {
    width: "15vw",
    maxWidth: 220,
    marginTop: 15,
    background: "white",
    borderRadius: 8,
    padding: "24px 16px",
    marginRight: 5,
  },
  sectionWrapperView: {
    width: "70vw",
    marginTop: 15,
    background: "white",
    borderRadius: 8,
    marginRight: 15,
    "@media (max-width: 1024px)": {
      width: "65vw",
    },
    "@media (max-width: 768px)": {
      width: "60vw",
    },
  },
  collapseButton: {
    marginBottom: 26,
    color: "#465869",
    letterSpacing: "0.1em",
    padding: "0 24px",
  },
  collapseText: {
    font: "500 12px/14px Manrope",
  },
  listWrapper: {
    listStyle: "none",
    paddingLeft: "none",
    "& li": {
      font: "700 16px/24px Manrope",
      color: "#93A9BD",
      cursor: "pointer",
      padding: "0 24px",
      "&:not(:last-child)": {
        marginBottom: 28,
      },
      "&.active": {
        color: "#465869",
      },
    },
  },
  disableListItem: {
    cursor: "default !important",
  },
  buttonsWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
    padding: "0 16px",
    justifyContent: "flex-start",
  },
  buttonText: {
    font: "700 14px/24px Manrope",
    marginLeft: 12,
  },
  buttonEstimate: {
    color: "#3F6280",
    border: "1px solid #3F6280",
  },
  headerView: {
    background: "#EDF5FB",
    borderRadius: "8px 8px 0 0",
    height: 80,
    padding: "1rem 2rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  headerViewTitle: {
    font: "700 16px/24px Manrope",
    color: "#308CDB",
  },
  iconButtonClose: {
    background: "#fff",
    width: 24,
    height: 24,
    fontSize: 16,
    color: "#308CDB",
    padding: 0,
  },
  componentSection: {
    maxHeight: "calc(100% - 80px)",
    overflowY: "auto",
  },
  componentItem: {
    padding: "0 24px 24px 24px",
  },
  componentTitle: {
    font: "700 16px/24px Manrope",
    color: "#465869",
    backgroundColor: "#F9FAFB",
    padding: "12px 24px",
  },
}));

export default styles;

export const Separator = styled("hr")(() => ({
  margin: "2rem 0",
}));
